import LiquidezPagamentoPJQuery from "../../common/query/LiquidezPagamentoPJQuery";
import LiquidezRecebimentoPJQuery from "../../common/query/LiquidezRecebimentoPJQuery";
import MediaDiasInadimplenciaPJQuery from "../../common/query/MediaDiasInadimplenciaPJQuery";
import ScoreEvolucaoPJQuery from "../../common/query/ScoreEvolucaoPJQuery";
import TitleStripe from "../../common/TitleStripe";
import PagamentosViaBoletoPJQuery from "../PagamentosViaBoletoPJQuery";
import PagamentosViaBoletoTedPJQuery from "../PagamentosViaBoletoTedPJQuery";
import PredicaoRecebimentoBoletoPJQuery from "../PredicaoRecebimentoBoletoPJQuery";
import RecebimentosViaBoletoPJQuery from "../RecebimentosViaBoletoPJQuery";
import RecebimentosViaBoletoTedCartaoPJQuery from "../RecebimentosViaBoletoTedCartaoPJQuery";
import ConcentracaoPagamentosPJQuery from "./ConcentracaoPagamentosPJQuery";
import ConcentracaoRecebimentoPJQuery from "./ConcentracaoRecebimentoPJQuery";

export default function InformacoesFinanceirasPJQuery({ dataFull }) {
  // Flags de existência (statusRetorno == 1)
  const hasRecBoleto = dataFull?.recebimentosViaBoletoPJ?.statusRetorno == 1;
  const hasPagBoleto = dataFull?.pagamentosViaBoletoPJ?.statusRetorno == 1;
  const hasRecBoletoTedCartao =
    dataFull?.recebimentosViaBoletoCartaoTedPJ?.statusRetorno == 1;
  const hasPagBoletoTed =
    dataFull?.pagamentosViaBoletoTedPJ?.statusRetorno == 1;

  const hasConcRec = dataFull?.concentracaoRecebimentoPJ?.statusRetorno == 1;
  const hasConcPag = dataFull?.concentracaoPagamentoPJ?.statusRetorno == 1;

  const hasLiqRec = dataFull?.liquidezRecebimentoPJ?.statusRetorno == 1;
  const hasLiqPag = dataFull?.liquidezPagamentoPJ?.statusRetorno == 1;

  const hasPredicao = dataFull?.predicaoRecebimentoBoletoPJ?.statusRetorno == 1;
  const hasMediaDias = dataFull?.mediaDiasInadimpleciaPJ?.statusRetorno == 1;

  // helpers (coloque no topo do arquivo ou onde mantiver seus utils)
  const toNum = (v) => {
    if (v == null) return null; // só "nulo" bloqueia a comparação; zero é válido
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };
  const brl = (v) =>
    (Number(v) || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  // valores dos indicadores (apenas números ou null)
  const recIndic = toNum(dataFull?.recebimentosViaBoletoCartaoTedPJ?.indicador);
  const pagIndic = toNum(dataFull?.pagamentosViaBoletoTedPJ?.indicador);

  // regra: só compara se ambos NÃO forem nulos
  const showTransactedMore =
    recIndic != null && pagIndic != null && recIndic < pagIndic;

  // Layout helpers
  const gridClass = (both) =>
    both ? "grid gap-4 grid-cols-2" : "grid gap-4 grid-cols-1";
  const pairLayout = (both) => (both ? "half" : "full");

  return (
    <div className="flex flex-col gap-4">
      {dataFull?.scoreEvolucaoPJ?.statusRetorno == 1 && (
        <div>
          <ScoreEvolucaoPJQuery score={dataFull?.scoreEvolucaoPJ?.score} />
        </div>
      )}

      {/* Recebimentos × Pagamentos via boleto */}
      {(hasRecBoleto || hasPagBoleto) && (
        <div>
          <TitleStripe>Valor transacionado</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Atribuí a uma empresa um valor médio de recebimento ou pagamento em
            grupo de mesmo perfil ao longo de um período. Na composição desse
            grupo são consideradas diversas variáveis atreladas ao CNPJ
            consultado, sendo as principais: região demográfica, setor de
            mercado (CNAE) e valor de recebimento (porte).
          </div>
          <div className={gridClass(hasRecBoleto && hasPagBoleto)}>
            {hasRecBoleto && (
              <RecebimentosViaBoletoPJQuery
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.recebimentosViaBoletoPJ}
              />
            )}
            {hasPagBoleto && (
              <PagamentosViaBoletoPJQuery
                // idem comentário acima
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.pagamentosViaBoletoPJ}
              />
            )}
          </div>
        </div>
      )}

      {(hasRecBoletoTedCartao || hasPagBoletoTed) && (
        <div>
          <TitleStripe>Valor transacionado</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Atribuí a uma empresa um valor médio de recebimento ou pagamento em
            grupo de mesmo perfil ao longo de um período. Na composição desse
            grupo são consideradas diversas variáveis atreladas ao CNPJ
            consultado, sendo as principais: região demográfica, setor de
            mercado (CNAE) e valor de recebimento (porte).
          </div>
          <div className={gridClass(hasRecBoletoTedCartao && hasPagBoletoTed)}>
            {hasRecBoletoTedCartao && (
              <RecebimentosViaBoletoTedCartaoPJQuery
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.recebimentosViaBoletoCartaoTedPJ}
              />
            )}
            {hasPagBoletoTed && (
              <PagamentosViaBoletoTedPJQuery
                // idem comentário acima
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.pagamentosViaBoletoTedPJ}
              />
            )}
          </div>
        </div>
      )}

      {/* Predição de recebimento (full width) */}
      {hasPredicao && (
        <div>
          <TitleStripe>Predição de Valor transacionado</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Projeta o valor médio mensal de pagamentos ou recebimentos de uma
            empresa para os próximos 12 meses. Utilizando modelagem com
            inteligência artificial e baseado no histórico de transações da
            empresa por boletos, cartão e TED.
          </div>
          <PredicaoRecebimentoBoletoPJQuery
            strategy="even"
            closedMonths
            showTable
            data={dataFull?.predicaoRecebimentoBoletoPJ}
          />
        </div>
      )}

      {/* Concentração de Recebimento × Concentração de Pagamento */}
      {(hasConcRec || hasConcPag) && (
        <div>
          <TitleStripe>Maior Concentração</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Indica como está a concentração de pagamentos ou recebimentos de
            boletos para um CNPJ em relação aos seus fornecedores ou clientes.
            Este índice foi criado com base no conceitual econômico para medir o
            grau de concorrência de uma empresa.
          </div>
          <div className={`${gridClass(hasConcRec && hasConcPag)}`}>
            {hasConcRec && (
              <ConcentracaoRecebimentoPJQuery
                layout={pairLayout(hasConcRec && hasConcPag)}
                data={dataFull?.concentracaoRecebimentoPJ}
              />
            )}
            {hasConcPag && (
              <ConcentracaoPagamentosPJQuery
                layout={pairLayout(hasConcRec && hasConcPag)}
                data={dataFull?.concentracaoPagamentoPJ}
              />
            )}
          </div>
        </div>
      )}

      {/* Liquidez de Recebimento × Liquidez de Pagamento */}
      {(hasLiqRec || hasLiqPag) && (
        <div>
          <TitleStripe>Saúde Financeira</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Indica como está a liquidez de recebimento de uma empresa, avaliando
            o valor dos boletos a receber/a pagar que estão sendo efetivamente
            recebidos/pagos em até 5 dias após da data de vencimento
          </div>
          <div className={gridClass(hasLiqRec && hasLiqPag)}>
            {hasLiqRec && (
              <LiquidezRecebimentoPJQuery
                layout={pairLayout(hasLiqRec && hasLiqPag)} // <-- agora dinâmico
                data={dataFull?.liquidezRecebimentoPJ}
              />
            )}
            {hasLiqPag && (
              <LiquidezPagamentoPJQuery
                layout={pairLayout(hasLiqRec && hasLiqPag)} // <-- agora dinâmico
                data={dataFull?.liquidezPagamentoPJ}
              />
            )}
          </div>
        </div>
      )}

      {/* Média de dias de inadimplência (full width) */}
      {hasMediaDias && (
        <div>
          <TitleStripe>Inadimplência</TitleStripe>
          <MediaDiasInadimplenciaPJQuery
            data={dataFull?.mediaDiasInadimpleciaPJ}
          />
        </div>
      )}
    </div>
  );
}
